import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setIsClearingReduxFormState } from 'state/ui'

interface Filter {
  name: string
  value: string
  path: string
}

interface FilterAction {
  filter: string
  value: string
}

interface SalesOrderState {
  salesOrderId: string
  filters: { [key: string]: Filter }
  duplicateSalesOrderId: string
  isSetup: boolean
}

const initialState: SalesOrderState = {
  salesOrderId: '',
  filters: {
    customer: {
      name: 'Customer',
      value: '',
      path: 'customer.displayName',
    },
    status: {
      name: 'Status',
      value: 'Open',
      path: 'status',
    },
  },
  duplicateSalesOrderId: '',
  isSetup: false,
}

export const salesOrderSlice = createSlice({
  name: 'salesOrder',
  initialState,
  reducers: {
    setSalesOrderId: (state, action: PayloadAction<string>) => {
      state.salesOrderId = action.payload
    },
    clearSalesOrderId: state => {
      state.salesOrderId = initialState.salesOrderId
    },
    setSalesOrderFilter: (state, action: PayloadAction<FilterAction>) => {
      const { filter, value } = action.payload
      state.filters[filter].value = value
    },
    clearSalesOrderFilters: state => {
      state.filters = initialState.filters
    },
    setDuplicateSalesOrderId: (state, action: PayloadAction<string>) => {
      state.duplicateSalesOrderId = action.payload
    },
    clearDuplicateSalesOrderId: state => {
      state.duplicateSalesOrderId = initialState.duplicateSalesOrderId
    },
    setIsSetup: (state, action: PayloadAction<boolean>) => {
      state.isSetup = action.payload
    },
    clearIsSetup: state => {
      state.isSetup = initialState.isSetup
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsClearingReduxFormState, (state, action) => {
      if (action.payload) {
        state.salesOrderId = initialState.salesOrderId
        state.filters = initialState.filters
        state.duplicateSalesOrderId = initialState.duplicateSalesOrderId
        state.isSetup = initialState.isSetup
      }
    })
  },
})

export const {
  setSalesOrderId,
  clearSalesOrderId,
  setSalesOrderFilter,
  clearSalesOrderFilters,
  setDuplicateSalesOrderId,
  clearDuplicateSalesOrderId,
  setIsSetup,
  clearIsSetup,
} = salesOrderSlice.actions

export default salesOrderSlice.reducer
